import React, { forwardRef, memo, useMemo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { generateSvgId } from 'src/lib/svg';

export const IconGoogle = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <g clipPath={`url(#&{svgId})`}>
          <path
            d="M2.89654 11.3983L7.76371 3.1543C8.38196 3.51441 11.4995 5.22139 12.003 5.54604L7.13585 13.7905C6.60356 14.4862 2.22217 12.4541 2.89654 11.3978V11.3983Z"
            fill="#FBBC04"
          />
          <path
            d="M16.8832 11.3967L12.0161 3.15323C11.3356 2.03288 9.87018 1.62574 8.6665 2.28745C7.46282 2.94915 7.09631 4.37454 7.77675 5.54492L12.6439 13.7894C13.3244 14.9092 14.7899 15.3163 15.9935 14.6547C17.1446 13.9929 17.5637 12.517 16.8832 11.3976V11.3967Z"
            fill="#3D7FFE"
          />
          <path
            d="M5.00571 14.9727C6.35505 14.9727 7.44891 13.9173 7.44891 12.6155C7.44891 11.3136 6.35505 10.2583 5.00571 10.2583C3.65636 10.2583 2.5625 11.3136 2.5625 12.6155C2.5625 13.9173 3.65636 14.9727 5.00571 14.9727Z"
            fill="#34A853"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="14.6602"
              height="13.0312"
              transform="translate(2.5625 1.96875)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
